var React = require('react');

function WhiteNextArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icons","transform":"translate(-1439 -3724)"},React.createElement("g",{"id":"Arrow","transform":"translate(1439 3724)"},[React.createElement("circle",{"id":"Ellipse_6","data-name":"Ellipse 6","cx":"24","cy":"24","r":"24","fill":"#fff","key":0}),React.createElement("path",{"id":"Path_3217","data-name":"Path 3217","d":"M7.57,7l7.2,7.2-7.2,7.2","transform":"translate(14.03 9.8)","fill":"none","stroke":"#000","strokeWidth":"4.5","key":1})])));
}

WhiteNextArrow.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48"};

module.exports = WhiteNextArrow;

WhiteNextArrow.default = WhiteNextArrow;
